<template>
    <div>
        <v-hover
            v-slot="{ hover }"
        >
            <v-card 
                :elevation="hover ? 6 : 1"
                class="mx-auto mb-4" 
                variant="outlined" 
                style="background-color: white;"
            >
                <div class="d-flex justify-space-between align-start pa-4 pb-2">
                    <div class="text-subtitle-1 font-weight-bold text-truncate">
                        {{ item.nome }}
                    </div>
                </div>

                <v-divider class="mx-4 my-0"></v-divider>

                <v-card-text class="py-3 px-4">
                    <div class="d-flex align-center text-body-2 text-medium-emphasis">
                        CRECI: {{ item.creci }}
                    </div>
                </v-card-text>

                <v-card-actions class="d-flex pa-4 bg-grey-lighten-5 justify-end">

                    <v-menu
                        top
                        offset-x
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                small
                            >
                                <v-icon>
                                    mdi-file-document-check-outline
                                </v-icon>
                            </v-btn>
                        </template>

                        <v-simple-table density="compact">
                            <tbody>
                                <tr>
                                    <td class="font-weight-bold text-caption">USUARIOS:</td>
                                    <td class="text-caption">{{ item.app_plan?.users }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold text-caption">IMÓVEIS:</td>
                                    <td class="text-caption">{{ item.app_plan?.properties }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold text-caption">CONDOMÍNIOS:</td>
                                    <td class="text-caption">{{ item.app_plan?.condominiums }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold text-caption">CONSTRUTORAS:</td>
                                    <td class="text-caption">{{ item.app_plan?.builders }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold text-caption">FACS:</td>
                                    <td class="text-caption">{{ item.app_plan?.customers }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-menu>
                    
                    <v-btn
                        class="ml-4"
                        @click.prevent="editItem(item.id)"
                        fab
                        small
                    >
                        <v-icon>
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                   
                </v-card-actions>
                
                
            </v-card>
        </v-hover>    
    </div>
</template>

<script>
export default {
    name: 'MobileReportCard',

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        editItem(id){
            this.$emit('callEditItem', id)
        },
    }
}   
</script>